import Vue from 'vue'
import axios from 'axios'
import { wallet } from '@/store/wallet'

axios.defaults.withCredentials = true

const service = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? process.env.VUE_APP_API_URL : '/',
  timeout: 500000,
})

service.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      wallet.isLoggedIn = false
    }
    return Promise.reject(error)
  }
)

export { service as axios }
